<div class="step-container">
  <h1>Alerts</h1>
  <fgbcl-errors></fgbcl-errors>
  <div *ngIf="optOutAlerts$ | async; else failed" class="mb-5">
    <div *ngFor="let optOutAlert of optOutAlerts">
      <div class="mb-2">
        <input
          class="form-check-input ml-1"
          type="checkbox"
          [(ngModel)]="optOutAlert.Value"
          [id]="optOutAlert.AlertId"
          required
        />
        <label class="form-check-label font-weight-bod pl-4 font-size-12" [for]="optOutAlert.AlertId">
          {{ optOutAlert.AlertDescription }}
        </label>
        <br />
      </div>
    </div>
  </div>

  <div class="button-container position-absolute">
    <fgb-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgb-registration-navigation>
  </div>
  <ng-template #failed> </ng-template>
</div>
